<template>
	<div>
		<div style="text-align: right;margin-bottom: 10px;" v-if="isSetting">
			<el-button type="primary" @click="handleAddGcyj">
				添加
			</el-button>
		</div>
		<data-table
			:table-data="gcyjData"
			:column="gcyjColumns"
			:loading="loadingStatus"
			:page-options="pageOptions"
			:border="true"
			:selection="false"
			:index="true"
			@page-change="handlePageChange"
		>
			<!-- 操作列 -->
			<template slot="slot_action" slot-scope="{ scope }">
				<el-button v-if="isSetting" type="text" @click="handleEdit(scope.row)">
					编辑
				</el-button>
				<el-button type="text" @click="handleSeeDetail(scope.row)">
					详情
				</el-button>
				<el-button v-if="isSetting" type="text" @click="handleDelete(scope.row)">
					删除
				</el-button>
			</template>
		</data-table>
		<!-- 技术负责人工程业绩表单-start -->
		<jr-dialog
			:visible.sync="jsfzrGcyjFormVisible"
			title="工程业绩"
			width="1400px"
			top="100px"
			:append-to-body="true"
			:showBtn="!isEdit"
		>
			<template slot="content" v-if="jsfzrGcyjFormVisible">
				<!-- 列表数据表单添加动态组件 -->
				<jsfzr-gcyj-form :jsfzrId="jsfzrId" ref="jsfzrGcyjForm" :isEdit="isEdit"></jsfzr-gcyj-form>
			</template>
			<template slot="footer" v-if="!isEdit">
				<el-button @click="jsfzrGcyjFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleSaveForm" :loading="visibleLoading">确 定</el-button>
			</template>
		</jr-dialog>
		<!-- 技术负责人工程业绩表单-end -->
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import DataTable from '@/components/JrTable/DataTable'
	import { queryGcyjData, saveGcyjData, removeGcyjData } from '@/api/certTreasure/materialRecord'
	import JsfzrGcyjForm from '../components/JsfzrGcyjForm.vue'
	import { arrayJoin, deepClone } from '@/utils/index'

	/**
	 * 技术负责人-工程业绩表格组件
	 */
	export default {
		name: 'JsfzrGcyj',
		components: {
			DataTable,
			JsfzrGcyjForm,
			JrDialog
		},
		props: {
			// 技术负责人id
			jsfzrId: {
				type: String,
				default: ''
			},
			// 是否编辑
			isEdit: {
				type: Boolean,
				default: false
			},
			// 是否设置
			isSetting: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				// 工程业绩表格
				gcyjData: [],
				gcyjColumns: [
					{ prop: 'xmmc', label: '项目名称', minWidth: '100' },
					{ prop: 'xmgmzb', label: '项目规模指标', minWidth: '100' },
					{ prop: 'xmdz', label: '项目地址', minWidth: '100' },
					{ prop: 'kssj', label: '开始时间', minWidth: '100' },
					{ prop: 'jssj', label: '结束时间', minWidth: '100' }
				],
				loadingStatus: false,
				pageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				// 添加工程业绩表单是否显示
				jsfzrGcyjFormVisible: false,
				visibleLoading: false
			}
		},
		created() {},
		mounted() {
			this.handleInitData()
		},
		methods: {
			handleInitData() {
				this.loadingStatus = true
				queryGcyjData({
					jsfzrId: this.jsfzrId,
					page: this.pageOptions.page,
					size: this.pageOptions.limit
				})
					.then(res => {
						this.loadingStatus = false
						this.gcyjData = res.data.records
						this.pageOptions.total = res.data.total
					})
					.catch(() => {
						this.loadingStatus = false
					})
			},
			// 添加工程业绩
			handleAddGcyj() {
				this.$emit('changeIsEdit', false)
				this.jsfzrGcyjFormVisible = true
			},
			handlePageChange() {},
			handleSaveForm() {
				this.$refs.jsfzrGcyjForm.handleSaveInfo().then(res => {
					this.handleSubmitData(res)
				})
			},
			// 提交方法
			handleSubmitData(res) {
				let deepFormData = deepClone(res)
				this.visibleLoading = true
				saveGcyjData(deepFormData)
					.then(() => {
						this.$modal.msgSuccess('保存成功')
						this.handleInitData()
						this.visibleLoading = false
						this.jsfzrGcyjFormVisible = false
					})
					.catch(() => {
						this.visibleLoading = false
						this.jsfzrGcyjFormVisible = false
					})
			},

			// 编辑操作
			handleEdit(row) {
				let rowData = { ...row }
				this.jsfzrGcyjFormVisible = true
				this.$emit('changeIsEdit', false)
				this.$nextTick(() => {
					this.$refs.jsfzrGcyjForm.form = JSON.parse(JSON.stringify(rowData))
				})
			},

			// 查看详情
			handleSeeDetail(row) {
				let rowData = { ...row }
				this.jsfzrGcyjFormVisible = true
				this.$emit('changeIsEdit', true)
				this.$nextTick(() => {
					this.$refs.jsfzrGcyjForm.form = JSON.parse(JSON.stringify(rowData))
				})
			},

			// 删除操作
			handleDelete(row) {
				const data = {
					id: row.id
				}
				this.$modal
					.confirm('请确认是否删除？')
					.then(() => {
						return removeGcyjData(data)
					})
					.then(() => {
						this.$modal.msgSuccess('操作成功')
						this.handleInitData()
					})
					.catch(() => {})
			}
		},
		watch: {
			isSetting: {
				handler: function(val) {
					this.gcyjColumns.push({
						slot: 'slot_action',
						label: '操作',
						minWidth: '120',
						fixed: 'right'
					})
				},
				immediate: true
			}
		}
	}
</script>

<style scoped></style>
